<template>
	<div class="shopify-automation-popup">
		<loading v-if="loading || loadingProducts" />
		<div class="layout-row flex flex-center product-box"
		     :class="{'empty':(!automation.content.product_id||!currentProduct)}">
			<div class="flex layout-row" v-if="productOpts.length">
				<div class="flex form-group with_top_block" style="margin-bottom: 0;">
					<span class="form_group_top_block">Product</span>

					<v-select placeholder="Select a product"
							:options="productOpts" :reduce="item => item.id" label="label"
							v-model="automation.content.product_id" @input="shProductSelect($event)"
							append-to-body v-if="productOpts.length">

						<template v-slot:option="option">
							<div class="select_option_with_img" style="color: inherit">
								<img v-if="option.image && option.image.src" class="opt-image" :src="option.image.src">
								<img v-else class="opt-image placeholder-img" :src="require('@/assets/img/placeholder-img.svg')">

								<span class="opt-title">{{ option.label }}</span>
							</div>
						</template>
						<template #selected-option="option">
							<div class="select_option_with_img" v-if="option && option.label">
								<img v-if="option.image && option.image.src" class="opt-image" :src="option.image.src">
								<img v-else class="opt-image placeholder-img" :src="require('@/assets/img/placeholder-img.svg')">
								<span class="opt-title">{{ option.label }}</span>
							</div>
							<div v-else class="_shopify-product-select-placeholder">
								<inline-svg :src="require('@/assets/img/search_icon_gray.svg')" />
								<span>Select a product to link to</span>
							</div>
						</template>
					</v-select>
					<v-spinner v-if="spin"/>
				</div>
			</div>

			<div class="quantity-box " style=""  v-if="currentProduct && automation.content.product_id">
        <span class="flex-none layout-row">
	        <inline-svg :src="require('@/assets/img/close_popup.svg')" />
        </span>

				<InputField label="QTY" info="Quantity"
						class="flex-none qty" type="number" min="1" max="200000" @input="shDone()"
				            :value="automation.content.qty" v-model.number="automation.content.qty"/>

			</div>
		</div>


<!--		<expandable-area v-if="currentProduct" title="Settings" tag="" name="automation.shopify.settings">-->
			<div class="bundling-box layout-row margin-t-15"  v-if="currentProduct && automation.content.product_id">
				<div class=" " style="margin-left: 20px">
					<v-switch label="Enable bundling?" :info="enableBundlingInfo" @change="shDone()"
					          :value="automation.content.bundle" v-model="automation.content.bundle">
					</v-switch>
				</div>

				<div v-if="automation.content.bundle" class="flex flex-center layout-row wait-for"
				     style="border-radius: 3px;padding: 5px 14px;margin: 0 0 0 10px;">
					<span class="">Wait at least </span>
					<InputField class="delay" type="number" min="1" max="120" @input="shDone()"
					            :value="automation.content.trigger_after" v-model.number="automation.content.trigger_after"/>
					<span class="" style="margin-left: 5px"><b>minutes</b> for the next order before bundling?</span>
				</div>

			</div>
<!--		</expandable-area>-->

		<expandable-area v-if="currentProduct && automation.content.product_id" close-by-default
		                 title="Additional settings" name="automations.shopify.settings" tag="(optional)">
			<div class="layout-row margin-t-10 margin-r-15" >
				<div class="flex margin-tb-auto" style="margin-left: 20px">
					<v-switch label="Update inventory level?" :info="updateInventoryInfo" @change="shDone()"
					          :value="automation.content.update_inventory" v-model="automation.content.update_inventory">
					</v-switch>

					<div class="layout-row flex-center margin-t-10" style="" >
						<div class="margin-r-15 ">
							<v-switch label="Override price?" info="<b>Override price</b> will replace the product price that is synced to Shopify with the given price."
							          @change="shDone()"
							          :value="automation.content.override_price" v-model="automation.content.override_price">
							</v-switch>
						</div>

						<div class="layout-row flex-center " v-if="automation.content.override_price">
							<span>
							New price
						</span>
							<InputField small class="flex-none override-price" type="number" min="0" max="9999999999"
							            @input="shDone()" :value="automation.content.price" v-model.number="automation.content.price"
							            placeholder="auto" prepend="$"/>
						</div>
					</div>
				</div>
				<div>
					<v-button @click="setNotes=true" label="Notes & dynamic variants..." border slim/>
					<shopify-notes-popup :config="automation.content.notes"
					                     :dynamicVariantsConfig="automation.content.dynamic_variants" @done="notesDone"
					                     v-if="setNotes" @close="setNotes=false"/>
				</div>

			</div>
		</expandable-area>

			<div class="product_link_box"  v-if="currentProduct && automation.content.product_id">
				<div class="layout-row">
					<div class="flex" style="padding: 0 5px;">
<!--						<label>Variant mapping</label>-->
						<p>Drag the Funnelish items towards the Shopify items in order to link them.</p>
					</div>

					<div class="btn_wrpr flex layout-row" style="align-items: center;padding-left: 5px;">
						<a @click="linkAll" class="btn brdr_btn link_item_btn">
							<inline-svg :src="require('@/assets/img/link_item_icon.svg')"/>
							Auto-link all variants
						</a>
						<a @click="unlinkAll" class="btn brdr_btn link_item_btn">
							<inline-svg :src="require('@/assets/img/unlink_item_icon.svg')"/>
							Unlink all variants
						</a>
					</div>
				</div>

				<div class="product_link_box_cols">
					<div class="left" v-if="variantOptions.length">
						<h3 class="col_title">Funnelish</h3>
						<div class="product_link_variant_wrpr">
							<ProductLinkVariantSource
									v-for="(item, index) in variantOptions" :item="item" :key="index"
									:draggable="allowedToLink(item.id)"
									@dragstart="onDragging($event)"
									:dataIndex="index + 1"
									:class="{disallow: !allowedToLink(item.id)}"
									:allowedToLink="allowedToLink(item.id)"
									@unlinkMe="unlinkMe"
							/>
						</div>
					</div>
					<div class="center" style="z-index: 2;">
						<svg style="overflow: visible;" width="100%" height="100%" v-html="svgString" ref="svg-lines">

						</svg>
					</div>
					<div class="right">
						<h3 class="col_title">Shopify</h3>
						<div class="product_link_variant_wrpr">
							<ProductLinkVariantTarget
									v-for="(item, index) in currentProductVariants"
									:key="index" :item="item"
									:findOptImage="findOptImage(item.image_id)"
									@drop="drop" @dragover="allowDrop($event)" :dataIndex="index + 1"
							/>
						</div>
					</div>
				</div>
			</div>
<!--		</expandable-area>-->

	</div>
</template>

<script>
import API from "@/api"
import {mapGetters} from "vuex"
import InputField from "@/components/base/input-field";
import SelectField from "@/components/base/select-field";
import VSwitch from "@/components/base/v-switch";
import InfoIcon from "@/components/base/info-icon";
import VSpinner from "@/components/base/v-spinner";
import ProductLinkVariantSource from "@/components/automation-parts/ProductLinkVariantSource";
import ProductLinkVariantTarget from "@/components/automation-parts/ProductLinkVariantTarget";
import VButton from "@/components/base/v-button";
import ShopifyNotesPopup from "@/components/popups/automation/integration-actions/shopify/shopify-notes-popup";
import Loading from "@/components/Loading";
import ExpandableArea from "@/components/base/expandable-area";

export default {
	name: 'Shopify',
	components: {
		ExpandableArea,
		Loading,
		ShopifyNotesPopup,
		VButton,
		VSpinner, InfoIcon, VSwitch, SelectField, InputField, ProductLinkVariantSource, ProductLinkVariantTarget,
	},
	mixins: [API],
	props:{
		automation:{
			type:Object,
			// default:()=> {}
		},
		product:{
			type:Object,
		},
	},
	data() {
		return {
			loading: false,
			loadingProducts: false,
			setNotes: false,
			spin: false,
			updateInventoryInfo: `          <p><b>If turned on,</b> Funnelish will attempt to decrement the inventory level of the product.</p>
          <p style="line-height: 20px;" class="details-box "><b>PS.</b> If turned on, make sure your product has sufficient inventory otherwise syncing with Shopify will fail if there isn't.</p>
          <p style="line-height: 20px;" class="details-box "><b>PPS.</b> If bundling is enabled make sure there is sufficient inventory for all products included in the bundle.</p>`,
			enableBundlingInfo: `          <p><b>If bundling is off,</b> then Funnelish will sync orders to Shopify as they are made on your funnel.</p>
          <p><b>If bundling is on,</b> then Funnelish will wait for the given time for the next order before attempting to sync to Shopify
            if there are no more waiting orders by the same customer.</p>
          <p>Usually <b>5 to 15 minutes</b> should be more than enough for a customer to take the next upsell on most OTOs.</p>`,
			productList: [],
			productOpts: [],
			variantOptions: [],
			currentProduct: false,
			currentProductVariants: [],
			defAutomation: {
				action_caption: "Action", //String
				list: null, //String
				send_to_optin_email: true, //Boolean
				tags: null, //String
				type_id: 1, //Integer
				config: null, //String
				content: {
					"price": null,
					"product_id": 0,
					"qty": 1,
					"trigger_after": 1,
					"bundle": false,
					"update_inventory": false,
					"notes": {},
					"dynamic_variants": {},
					"links": []
				}
			},
			svgString: '',
		}
	},
	computed: {
		isValid(){
			return !!this.automation.content.product_id
		},
		isPlus(){
			return this.$route.meta.isFPlus;
		},
		productVariantsLength() {
			return this.currentProductVariants.length
		},
		productsLength() {
			return this.productList.length
		},
		contentLinks() {
			return this.automation.content ? this.automation.content.links : []
		},
	},
	watch: {
		productVariantsLength(val) {
			if (val && this.automation) {
				setTimeout(() => {
					this.drawLines(this.contentLinks);
				}, 100);
			}
		},
		productsLength(val) {
			if (val && this.automation && this.automation.content) {
				this.shProductSelect(this.automation.content.product_id, false);
			}
		},
		contentLinks(val) {
			this.$nextTick(()=>{
				this.drawLines(val);
			})
		}
	},
	methods: {
		drawLines() {
			var string = `<defs>
                            <marker id="head" viewBox="0 0 10 10" refX="5" refY="5" orient="auto" >
                                <circle fill="red" cx="5" cy="5" r="5" />
                            </marker>
                          </defs>`;
			this.contentLinks.forEach(link => {
				var srcEl = document.getElementById(link.srcId) || false;
				var tagetEl = document.getElementById(link.targetId) || false;
				if (srcEl && tagetEl) {
					var srcIndex = srcEl.getAttribute('data-index');
					var srcY = (srcIndex * 46) + (srcIndex * 10) - 23;
					var targetIndex = tagetEl.getAttribute('data-index');
					var targetY = (targetIndex * 46) + (targetIndex * 10) - 23;
					string += `<line marker-end='url(#head)' marker-start='url(#head)' x1="0" y1="${srcY}" x2="130" y2="${targetY}" style="stroke: #97AACD;stroke-width: 2px;"></line>`
				}
			});
			this.svgString = string;
			this.shDone();
		},
		allowedToLink(id) {
			if (this.automation.content.links.length > 0) {
				var result = true;
				this.automation.content.links.forEach(link => {
					if (link.srcId == id) result = false
				})
				return result
			} else return true
		},
		unlinkMe(id) {
			if (this.automation.content.links.length > 0) {
				var result = false,
						resultIndex;
				this.automation.content.links.forEach((link, index) => {
					if (link.srcId == id) {
						resultIndex = index;
						result = true;
					}
				})
				result ? this.automation.content.links.splice(resultIndex, 1) : ''
			}
		},
		linkAll(error = true) {
			let foundAny = false;
			this.automation.content.links = [];
			this.variantOptions.forEach((option, optionIndex) => {
				this.currentProductVariants.forEach((variant, variantIndex) => {
					if (option.title.toLowerCase() === variant.title.toLowerCase()) {
						foundAny = true;
						this.automation.content.links.push({srcId: option.id + "", targetId: variant.id + ""});
					} else if (option.title.toLowerCase() === "main product" && variant.title.toLowerCase() === "default title") {
						foundAny = true;
						this.automation.content.links.push({srcId: option.id + "", targetId: variant.id + ""});
					}
				});
			});
			if (!foundAny && error) {
				this.$warn('',"No variant(s) in Funnelish™ match those in Shopify.")
			}
		},
		async shAction() {
			try {
				this.loadingProducts = true;
				this.productList = [];
				this.productList = await this.api.integrations.method("shopify", "get-products", {id: 0, arg1: "", arg2: ""});

				this.productList.forEach(prod => this.productOpts.push({
					id: prod.id,
					label: prod.title,
					image: prod.image,
					text: `<img class="opt-image" src="${prod.image.src}"><span class="opt-title">${prod.title}</span>`
				}))

				if (this.isPlus) this.variantOptions = await this.api.wsteps.getOptions(this.product.id);
				else this.variantOptions = await this.api.steps.getOptions(this.product.id);
			} catch (e) {
				this.$error(e, "Something went wrong... Try again later, or contact support!")
			} finally {
				this.loadingProducts = false;
			}
		},
		async shProductSelect(val, unlink = true) {
			try {
				this.spin = true;
				this.currentProductVariants = [];
				unlink ? this.unlinkAll() : '';

				if (val && val !== "0") {
					this.currentProduct = this.productList.find(prod => prod.id === parseInt(val));
					let variants = await this.api.integrations.method("shopify", "get-product-variants", {
						id: 0,
						arg1: val + "",
						arg2: ""
					});
					this.currentProductVariants = variants;

					unlink ? this.linkAll(false) : ''; // Auto link.
				}
			} catch (e) {
				this.$error(e,"Couldn't load product variants, try again later!")
			} finally {
				this.spin = false;
				this.$nextTick(()=>this.$emit('valid', this.isValid))
			}
			this.automation.content.product_id = parseInt(val);

			this.shDone();
		},
		findOptImage(imageId) {
			if (!this.currentProduct.images) return false;
			let image = this.currentProduct.images.find(img => img.id === imageId);
			return image ? image.src : false
		},
		onDragging(ev) {
			ev.dataTransfer.setData("text", ev.target.id + ""); // as string
		},
		allowDrop(ev) {
			ev.preventDefault();
		},
		drag(ev) {
			ev.dataTransfer.setData("text", ev.target.id + ""); // as string
		},
		drop(ev) {
			ev.preventDefault();
			let data = ev.dataTransfer.getData("text");
			this.automation.content.links.push({srcId: data, targetId: ev.target.id + ""});
			this.shDone();
		},
		unlinkAll() {
			this.automation.content.links = [];
			this.shDone();
		},

		notesDone(notesData, dynamicVariantsData) {
			this.automation.content.notes = JSON.parse(JSON.stringify(notesData));
			this.automation.content.dynamic_variants = JSON.parse(JSON.stringify(dynamicVariantsData));
			this.setNotes = false;
			this.shDone();
		},

		shDone() {
			let product = this.currentProduct ? this.currentProduct.title : "No product";
			let qty = this.automation.content.qty || 0;
			this.automation.action_caption = `${qty} x ${product}`;

			// prevent strings
			if (this.automation.content.price==="")
				this.automation.content.price = null;

			this.$emit('done', this.automation);
			this.$store.commit("continueBtnStatusChange", true);
		},
	},
	async created() {
		if (this.automation) {
			this.automation.type_id = 1// create_order is the only supported action.
			if (!this.automation.content)
				this.$set(this.automation, 'content', JSON.parse(JSON.stringify(this.defAutomation.content)))
		}
		await this.shAction()
	}

}
</script>
<style lang="scss">
.shopify-automation-popup {
	._shopify-product-select-placeholder {
		display: flex;
		flex-direction: row;
		align-items: center;
		color: $dark-grey;
		svg {
			margin-right: 10px;
			height: 18px;
		}
	}
	.expandable-area {
		margin-top: 10px;
		margin-bottom: 10px;
		.area-content {
			padding: 10px 5px 10px;
			background: #f6f9fd;
			border-radius: 0 0 10px 10px;
			margin-top: -5px;
		}
		.expandable-title {
			font-size: 14px;
			background: #f6f9fd;
		}
	}
}
</style>
<style lang="scss" scoped>
.product-box {
	position: sticky;
	top: 0;
	background: white;
	z-index: 4;
	padding-top: 5px;
	border-bottom: 1px solid rgba(0, 0, 0, 0.1);
	&.empty {
		border-bottom: none;
	}
}
.product_link_box {
	.link_item_btn {
		flex-shrink: 0;
	}
}
.override-price {
	min-width: 120px;
	margin-left: 10px;
}
.quantity-box {
	border-radius: 3px;
	padding: 5px 14px;
	//background: #f6f9fd;
	align-items: center;
	display: flex;
	flex-direction: row;
	margin: 5px 0 5px 0;

	.qty {
		min-width: 90px;
		margin-right: 0;
		margin-left: 15px;
	}
}

.bundling-box {
	border-radius: 3px;
	padding: 5px 14px;
	margin: 5px 0 5px 0;
	background: #f6f9fd;
	align-items: center;
	height: 42px;

	.wait-for {
		border-radius: 3px;
		padding: 2px 14px;
		margin: 0 0 0 10px;
		display: flex;
		align-items: center;

	}

	.delay {
		min-width: 75px;
		margin-right: 5px;
		margin-left: 5px;
	}
}

.bundling-box .input-field, .quantity-box .input-field {
	height: 32px;
}

.product-row {
	align-items: center;
	display: flex;

	.with_top_block {
		margin-bottom: 0;
	}
}

.x_spr {
	display: flex;
	align-items: center;
	justify-content: center;
	font-weight: bold;
	font-size: 14px;
	line-height: 150%;
	letter-spacing: 0.02em;
	color: #C5C7D2;
	margin: 0 15px;
	margin-bottom: 27px;
}

.select_option_with_img {
	display: flex;
	align-items: center;
	font-size: 13px;
	color: #8b8c93;
	padding: 2px 0px;
}
</style>
